import { ListCollectionsWebEndpoint } from '@nucleus/web-hosting';
import { useUser } from '@nucleus/web-theme';
import { InfiniteData, UseSuspenseInfiniteQueryResult, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { queryCollections } from '../queries/collection';

type QueryResult = Awaited<ReturnType<typeof queryCollections>>;

export const useCollections = (
  engineId: string | undefined,
  collection?: 'playlists' | 'tags' | 'speakers' | 'books',
  params?: ListCollectionsWebEndpoint<any>['queryStringParameters']
): UseSuspenseInfiniteQueryResult<InfiniteData<QueryResult>> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseInfiniteQuery({
    queryKey: ['sermonHub', 'collection', collection, currentUser?.id, params],
    queryFn: ({ pageParam }) => queryCollections(engineId, collection, jwtToken, { ...params, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.cursor,
  });
};
